import axios from 'axios';
import { API_ENDPOINTS } from './api-endpoints';
import { HttpClient } from './http-client';

export const orderClient = {

  getOrderList: (variables: any) => {
    return HttpClient.post<any>(API_ENDPOINTS.ORDER_LIST, variables);
  },
  paymentInitiate: (variables: any, token?: string) => {
    return HttpClient.post<any>(API_ENDPOINTS.PAYMENT_INITIATE, variables, token ? { _urlToken: token } : undefined);
  },
  orderPayment: (variables: any) => {
    return HttpClient.post<any>(API_ENDPOINTS.ORDER_PAYMENT, variables);
  },
  verifyPaymentSession: (variables: { token: string }) => {
    return HttpClient.post<any>(API_ENDPOINTS.VERIFY_PAYMENT_SESSION, variables);
  },

  checkoutOrder: (variables: any, token?: string) => {
    return HttpClient.post<any>(API_ENDPOINTS.CHECKOUT_ORDER, variables, token ? { _urlToken: token } : undefined);
  },

  initiateOrderPurchase: async (token: string) => {
    // Create a new axios instance without the interceptor for this specific call
    const customAxios = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    return customAxios.post(API_ENDPOINTS.INITIATE_ORDER_PURCHASE, {});
  },
};
